import { Component, Inject, OnInit, ViewEncapsulation } from "@angular/core";
import {
  FormControl,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { AddNode, StorageDomains } from "src/app/core/models/node";
import { GatewayService } from "src/app/core/services/gateway.service";
import { HeaderService } from "src/app/core/services/header.service";
import { NodeService } from "src/app/core/services/node.service";
import { GatewayDTO } from "src/app/core/models/gateway";
import { MatSnackBar, MatSnackBarRef } from "@angular/material/snack-bar";
import { NgxSpinnerService } from "ngx-spinner";
import { Node } from "src/app/core/models/node";
import { ConfigEntityService } from "../../../../core/services/config-entity.service";
import { Deployment } from "../../../../core/models/deployment";
import { DeploymentService } from "../../../../core/services/deployment.service";
import { CloudTypes, NodeProvisionSource } from "src/app/core/models/globals";
import { tap } from "rxjs";
import { NodeConfigService } from "../../../../core/services/node-config.service";
import { HpcConfig } from "../../../../core/models/node-config";
import { NONE_TYPE } from "@angular/compiler";

@Component({
  selector: "app-add-node",
  templateUrl: "./add-node.component.html",
  styleUrls: ["./add-node.component.scss"],
  // encapsulation: ViewEncapsulation.None
})
export class AddNodeComponent implements OnInit {
  constructor(
    public dialog: MatDialogRef<AddNodeComponent>,
    @Inject(MAT_DIALOG_DATA)
    public data: { depName: string; cloudType: string; nodeList: Node[] },
    public nodeService: NodeService,
    public depService: DeploymentService,
    public configService: ConfigEntityService,
    private _spinner: NgxSpinnerService,
    private _headerService: HeaderService,
    private _gatewayService: GatewayService,
    private nodeConfigService: NodeConfigService,
    private _snackBar: MatSnackBar
  ) {}

  deployments: string[] = !this.data.depName
    ? this._headerService.getQuickAccessDeploymentNames()
    : [this.data.depName];
  addNodeForm: UntypedFormGroup;
  // depName: string = !this.data.depName ? this.deployments[0] : this.data.depName;
  depName: string = this.data.depName ? this.data.depName : null;
  cloudType: string = this.data.cloudType;
  gatewayNames: string[] = [];
  isFormSubmitted;
  selectedDep: string = null;
  nodeNames: string[] = [];
  osName: string = "WINDOWS";
  wsList: Node[];
  nodeConfigNames: string[] = [];
  currentDep: Deployment;
  nodeTypeList: any = [];
  cloudProvidersList: string[] = [];
  hpcNodeConfigs: HpcConfig[] = [];
  allDiskTypesAvailable: string[] = [];
  hostDevices: string[] = [];
  isoList: string[] = [];
  allTemplatesAvailable: string[] = [];
  provisionSourceList: string[] = [];
  storageDomainsList: StorageDomains[] = [];
  refDiskList: string[] = [];
  refDiskSelected: boolean = false;
  nodeProvisionSourceArray: string[] = Object.values(NodeProvisionSource);
  isKvmDep: boolean = false;
  skipCloudDeploymentMessage: string = "";
  disableSubmit = false;
  private snackBarRef?: MatSnackBarRef<any>;


  ngOnInit(): void {
    if (!this.data.depName) {
      this.deployments.splice(0, 0, "None");
    }
    this.nodeService.getAllWorkstations().subscribe((data) => {
      this.wsList = <Node[]>JSON.parse(JSON.stringify(data));
    });
    if (this.depName == null || this.depName == "All") {
      this.nodeTypeList = [{ name: "Workstation", value: 3 }];
    } else {
      this.depService.checkIsVdi(this.depName).subscribe({
        next: (data) => {
          if (!Boolean(data)) {
            this.nodeTypeList = [
              { name: "Head Node", value: 0 },
              { name: "License Server", value: 1 },
              { name: "VPN Server", value: 2 },
              { name: "Workstore", value: 4 },
              { name: "Compute Node + Workstore", value: 5 },
              { name: "Compute Node", value: 6 },
              { name: "Head + Compute + Workstore Node", value: 7 },
              { name: "Head + Workstore Node", value: 8 },
              { name: "Gpu + Compute", value: 9 },
              { name: "Workstation", value: 3 },
              { name: 'Secondary Head Node', value: 14}
            ];
          } else {
            this.nodeTypeList = [
              { name: "Workstation", value: 3 }, 
              { name: "Host (HW)", value: 12 }
            ];
          }
        },
      });
    }
    if (this.data.nodeList) {
      this.data.nodeList.forEach((n) => {
        this.nodeNames.push(n.vmName.toLowerCase());
      });
    }
    this.addNodeForm = new UntypedFormGroup({
      deploymentName: new UntypedFormControl(this.depName),
      computerName: new UntypedFormControl(null, [Validators.required, Validators.minLength(2), Validators.pattern("^(?!-)[A-Za-z0-9-]{2,63}(?<!-)$")]),
      nodeType: new UntypedFormControl("3"),
      platformType: new UntypedFormControl("WINDOWS"),
      allowConnect: new UntypedFormControl("true"),
      skipCloudDeployment: new UntypedFormControl({ value: true, disabled: false }),
      externalIp: new UntypedFormControl(null),
      internalIp: new UntypedFormControl(null),
      macAddress: new UntypedFormControl(null, [
        Validators.pattern(
          "^((([0-9A-F]{2}:){5})|(([0-9A-F]{2}-){5})|([0-9A-F]{10}))([0-9A-F]{2})$"
        ),
      ]),
      gateway: new UntypedFormControl(""),
      nodeSize: new UntypedFormControl("Standard_D2s_v3"),
      image: new FormControl(null),
      osDiskType: new UntypedFormControl("Standard_LRS"),
      cloudProviders: new UntypedFormControl(this.cloudProvidersList[0]),
      hostDevices: new UntypedFormControl(this.hostDevices[0]),
      storageDomain: new UntypedFormControl("Default", [Validators.required]),
      provisionSource: new UntypedFormControl(
        NodeProvisionSource.TxtTemplate
      ),
      numofnodes: new UntypedFormControl(1, [
        Validators.required,
        Validators.pattern("^[1-9][0-9]*$"),
      ]),
    });
    this.getGatewayDetails();
    this.nodeConfigService.getHpcConfigDetails(this.depName).subscribe({
      next: (data) => {
        if (data) {
          this.hpcNodeConfigs = JSON.parse(JSON.stringify(data));
          if (this.hpcNodeConfigs) {
            this.nodeConfigNames = this.hpcNodeConfigs?.map(
              (nd) => nd?.instanceCode
            );
          }
        }
      },
      error: (err) => {},
    });
    this.addNodeForm.controls["nodeType"].valueChanges.subscribe((val) => {
      if (!val) {
        this.onClose;
        return;
      }
    });
    if (!this.data.depName) {
      this.getConnectorType(this.deployments[0]);
    } else {
      this.getConnectorType(this.data.depName);
    }
    this.addNodeForm.controls["numofnodes"].valueChanges.subscribe((val) => {
      if (val > 1) {
        this.addNodeForm.controls["internalIp"].disable();
        this.addNodeForm.controls["internalIp"].setValue(null);
        this.addNodeForm.controls["macAddress"].disable();
        this.addNodeForm.controls["macAddress"].setValue(null);
        this.addNodeForm.controls["externalIp"].disable();
        this.addNodeForm.controls["externalIp"].setValue(null);
      } else {
        this.addNodeForm.controls["internalIp"].enable();
        this.addNodeForm.controls["macAddress"].enable();
        this.addNodeForm.controls["externalIp"].enable();
      }
    });

    this.addNodeForm.controls["provisionSource"].valueChanges.subscribe((val) => {
      
    });
    this.provisionSourceChange(this.addNodeForm.controls["provisionSource"].value);
  }

  ngAfterViewInit() {
    //this.ifDeploymentOnPremise();
  }

  getGatewayDetails() {
    this._gatewayService.getAllGateways().subscribe((data: GatewayDTO[]) => {
      if (data) {
        this.gatewayNames = data.map((gw) => gw.name);
      }
    });
  }

  onClose() {
    this.dialog.close(false);
  }

  onSubmit(form) {
    if (!form.valid) {
      this.addNodeForm.markAllAsTouched();
      return;
    }
    let nodeName: string = form.value.computerName;
    let nodeIp: string = form.value.vmIp;
    if (this.nodeNames.includes(nodeName.toLowerCase())) {
      this._snackBar.open(
        "Node Name Already Exists. Please Enter Unique Node Name, including Lowercase and Uppercase Letters.",
        "OK",
        {
          duration: 5000,
        }
      );
      return;
    }
    if (this.wsList && this.wsList.length > 0) {
      if (this.wsList.find((el) => el.vmIp === nodeIp)) {
        this._snackBar.open(
          "IP Address Already Exists. Please Enter Unique IP Address.",
          "Ok",
          {
            duration: 5000,
          }
        );
        return;
      }
    }
    this.isFormSubmitted = true;
    let isWorkStation = form.value.nodeType == "3";
    if (form.value.deploymentName != "None") {
      this.selectedDep = form.value.deploymentName;
    }

    let externalIp = form.value.externalIp;
    let internalIp = form.value.internalIp;
    const ipAddressRegex = /^(?:[0-9]{1,3}\.){3}[0-9]{1,3}$/;

    if (internalIp) {
      if (!ipAddressRegex.test(internalIp)) {
        this._snackBar.open(
          "Please enter appropriate internal IP Address.",
          "Ok",
          {
            duration: 5000,
          }
        );
        this.isFormSubmitted = false;
        return;
      }
    }

    if (externalIp) {
      if (!ipAddressRegex.test(externalIp)) {
        this._snackBar.open(
          "Please enter appropriate external IP Address.",
          "Ok",
          {
            duration: 5000,
          }
        );
        this.isFormSubmitted = false;
        return;
      }
    }

    let storageDomainId = null;
    let nodeProvisionSource = form.value.provisionSource;

    if (nodeProvisionSource && this.isKvmDep == true) {
      if (nodeProvisionSource == NodeProvisionSource.TxtReferenceDisk) {
        if (form.value?.storageDomain) {
          storageDomainId = this.storageDomainsList.filter(
            (x) => x.name == form.value?.storageDomain
          )![0]?.id;
        }

        if (!storageDomainId) {
          this._snackBar.open(
            "Id is not available for selected storage domain.",
            "Ok",
            {
              duration: 5000,
            }
          );
          return;
        }
      }
    }

    let nodeData: AddNode[] = [
      {
        // DeploymentName: !isWorkStation ? form.value.deploymentName : this.data.depName,
        DeploymentName: this.selectedDep,
        MachineName: form.value.computerName,
        NodeType: form.value.nodeType,
        PlatformType: form.value.platformType,
        AllowConnect: !isWorkStation
          ? JSON.parse(form.value.allowConnect)
          : false,
        MacAddress: isWorkStation ? form.value.macAddress : null,
        IpAddress: form.value.internalIp,
        PublicIP: form.value.externalIp,
        GatewayName: isWorkStation ? form.value.gateway : null,
        SkipCloudDeployment: form.value.skipCloudDeployment ? form.value.skipCloudDeployment : false,
        NewMachineName: "",
        NewGatewayName: "",
        NewIpAddress: "",
        NewMacAddress: "",
        NewPublicIP: "",
        ConnectorType: form.value?.cloudProviders?.toString(),
        NodeSize: form.value.nodeSize,
        OsDiskType: form.value?.osDiskType,
        Image: form.value?.image,
        HostId: form.value?.hostDevices ? form.value?.hostDevices : null,
        StorageDomain: form.value?.storageDomain
          ? form.value?.storageDomain
          : null,
        ImageId: null,
        StorageDomainId: storageDomainId ? storageDomainId : null,
        ProvisionSource: form.value.provisionSource
          ? form.value.provisionSource
          : null,
        NumberOfNodes: form.value.numofnodes ? form.value.numofnodes : 0,
      },
    ];
    this._spinner.show("addNode");
    this.nodeService
      .addNode(nodeData)
      .pipe(tap((d) => this._spinner.show("addNode")))
      .subscribe({
        next: (data: any) => {
          this._spinner.hide("addNode");
          this._snackBar.open(data.actionMessage, "OK", {
            duration: 5000,
          });
          this.dialog.close(true);
        },
        error: (err) => {
          this._spinner.hide("addNode");
          this._snackBar.open(err.error.actionMessage, "OK", {
            duration: 5000,
          });
          this.isFormSubmitted = false;
          this.dialog.close();
        },
      });
    //this._spinner.hide("addNode")
  }

  getConnectorType(depName) {
    this._spinner.show("addNode");
    this.nodeService.getConnectorType(depName).subscribe({
      next: (data: any) => {
        this._spinner.hide("addNode");
        if (data) {
          this.cloudProvidersList = data?.cloudProviderValue?.split(",");
          this.addNodeForm.controls["cloudProviders"].setValue(
            this.cloudProvidersList[0]
          );
          if (this.cloudProvidersList) {
            if (this.cloudProvidersList![0] == CloudTypes.KVM) {
              this.isKvmDep = true;
              this.addNodeForm.controls["skipCloudDeployment"].setValue(false);
              this.addNodeForm
                .get("image")
                .setValidators([Validators.required]);
              this.skipCloudDeploymentMessage = "Skip Infra Deployment";
            } else {
              this.isKvmDep = false;
              //this.addNodeForm.controls["skipCloudDeployment"].setValue(true);
              this.skipCloudDeploymentMessage = "Skip Infra Deployment";
            }
          }

          if (data?.nodeConfigs) {
            this.nodeConfigNames = JSON.parse(
              JSON.stringify(data?.nodeConfigs)
            );
          }

          if (data?.hostDevices) {
            this.hostDevices = JSON.parse(JSON.stringify(data?.hostDevices));
          }

          if (data?.allDiskTypesAvailable) {
            this.allDiskTypesAvailable = JSON.parse(
              JSON.stringify(data?.allDiskTypesAvailable)
            );
          }

          if (data?.isoList) {
            this.isoList = JSON.parse(JSON.stringify(data?.isoList));
          }

          if (data?.templates) {
            this.allTemplatesAvailable = JSON.parse(
              JSON.stringify(data?.templates)
            );
            this.provisionSourceList = this.allTemplatesAvailable;
          } else {
            this.allTemplatesAvailable = ["Blank"];
            this.provisionSourceList = this.allTemplatesAvailable;
          }

          if (data?.storageDomains) {
            this.storageDomainsList = <StorageDomains[]>(
              JSON.parse(JSON.stringify(data?.storageDomains))
            );
          }

          if (data?.hostDevices) {
            this.hostDevices = JSON.parse(JSON.stringify(data?.hostDevices));
          }

          if (data?.refDiskList) {
            this.refDiskList = JSON.parse(JSON.stringify(data?.refDiskList));
            // this.provisionSourceList = this.refDiskList;
          }
        }
        this._spinner.hide("addNode");
      },
      error: (err) => {
        this._spinner.hide("addNode");
      },
    });
  }

  ifDeploymentOnPremise() {
    let isOnPremise =
      this._headerService.getCloudNameForDeployment(
        this.addNodeForm.get("deploymentName").value
      ) == CloudTypes.OnPremise;
    if (isOnPremise) {
      this.addNodeForm
        .get("externalIp")
        .setValidators([
          Validators.required,
          Validators.pattern(
            "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$"
          ),
        ]);
      this.addNodeForm
        .get("internalIp")
        .setValidators([
          Validators.required,
          Validators.pattern(
            "^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5]).){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])$"
          ),
        ]);
    } else {
      this.addNodeForm.get("externalIp").clearValidators();
      this.addNodeForm.get("internalIp").clearValidators();
    }
    this.addNodeForm.get("externalIp").updateValueAndValidity();
    this.addNodeForm.get("internalIp").updateValueAndValidity();
    return isOnPremise;
  }

  cloudProviderChanged(cloud) {
    if (cloud) {
      if (cloud == CloudTypes.KVM) {
        this.isKvmDep = true;
        this.addNodeForm.controls["skipCloudDeployment"].setValue(false);
        this.addNodeForm.get("image").setValidators([Validators.required]);
        this.skipCloudDeploymentMessage = "Skip Infra Deployment";
      } else {
        this.isKvmDep = false;
        //this.addNodeForm.controls["skipCloudDeployment"].setValue(true);
        this.addNodeForm.get("image").clearValidators();
        this.skipCloudDeploymentMessage = "Skip Infra Deployment";
      }
    }
  }

  provisionSourceChange(provSource) {
    //if (provSource?.toLowerCase() == NodeProvisionSource.TxtISO) {
    //  this.provisionSourceList = this.isoList;
    //  this.refDiskSelected = false;
    //}
    //else
    if (
      provSource?.toLowerCase() == NodeProvisionSource.TxtTemplate.toLowerCase()
    ) {
      this.provisionSourceList = this.allTemplatesAvailable;
      this.addNodeForm.controls["storageDomain"].disable();
      this.refDiskSelected = false;

      if (this.addNodeForm.controls["numofnodes"].value > 1) {
        this.addNodeForm.controls["internalIp"].disable();
        this.addNodeForm.controls["macAddress"].disable();
        this.addNodeForm.controls["externalIp"].disable();
      }
      this.snackBarRef?.dismiss();
      this.disableSubmit = false;
    } else if (
      provSource?.toLowerCase() ==
      NodeProvisionSource.TxtReferenceDisk.toLowerCase()
    ) {
      this.snackBarRef = this._snackBar.open(
        'The reference disk you are using should not be of any active running VM, else VM will create but not disk for it.',
        'OK',
        { duration: 10000 }
      );

      // handle "OK" click
      this.snackBarRef.onAction().subscribe(() => {
        this.disableSubmit = false;
        this.snackBarRef?.dismiss();
      });
      this.provisionSourceList = this.refDiskList;
      this.addNodeForm.controls["storageDomain"].enable();
      this.addNodeForm.controls["internalIp"].enable();
      this.addNodeForm.controls["macAddress"].enable();
      this.addNodeForm.controls["externalIp"].enable();
      this.addNodeForm.controls["numofnodes"].setValue(1);
      this.refDiskSelected = true;
    }
  }
}
